import { createFileRoute } from '@tanstack/react-router';
import { ExpenditurePurposeRouteComponent } from '@/app/route-components/settlement-statistics-converter/ExpenditurePurposeRouteComponent';
import { requireReleaseFlag } from '@/entities/session/lib/releaseGuard';

/**
 * 決算統計コンバーター結果詳細ルート（マスタ - 歳出目的）
 */
export const Route = createFileRoute(
  '/_protected/settlement-statistics-converter/$resultId/master/',
)({
  component: ExpenditurePurposeRouteComponent,
  beforeLoad: () => {
    requireReleaseFlag('settlement_statistics_converter');
  },
});
